
import {isTouchDevice} from './utils';
import {statements, ids, timelines} from './data';
import {gsap} from 'gsap';

export const initEventsNav = () => {
    document.querySelectorAll('.invisible-circle').forEach(elem => {
        if (!isTouchDevice) {
            elem.addEventListener('mouseenter', function() {
                if (!statements.animation_running) {
                    const targetMain    = document.querySelector(this.getAttribute('data-target'));
                    const targetNavbar  = document.querySelector(this.getAttribute('data-path-start-id'));
                    
                    if (targetMain && targetNavbar && !this.classList.contains('opened')) {
                        targetMain.animation.play();
                        targetNavbar.animation.play();
                    }
                }
            });

            elem.addEventListener('mouseleave', function() {
                if (!statements.animation_running) {
                    const targetMain    = document.querySelector(this.getAttribute('data-target'));
                    const targetNavbar  = document.querySelector(this.getAttribute('data-path-start-id'));
                    
                    if (targetMain && targetNavbar && !this.classList.contains('opened')) {
                        targetMain.animation.reverse();
                        targetNavbar.animation.reverse();
                    }
                }
            });
        }

        elem.addEventListener('click', function() {
            if (!statements.animation_running) {
                statements.animation_running    = true;

                const targetMain        = document.querySelector(this.getAttribute('data-target'));
                const targetNavbar      = document.querySelector(this.getAttribute('data-path-start-id'));
                const activeElem        = document.querySelector('.navbar-list.active');
                let activeNavBar        = null;
                if (activeElem != null) {
                    activeNavBar = document.querySelector(activeElem.getAttribute('data-path-start-id'));
                }
                const targetNavbarList  = document.querySelector(this.getAttribute('data-target-navbar'));

                if (targetMain && targetNavbar && !this.classList.contains('opened')) {
                    targetNavbar.animation.reverse();
                    targetMain.animation.reverse();
                }

                if (!statements.section_active) {
                    gsap.to(ids.taglineTop, {duration: 0.2, opacity: 0, scaleX: 0});
                    gsap.to(ids.taglineBottom, {duration: 0.2, opacity: 0, scaleX: 0});
                    timelines.main.timeScale(2.9).reverse();
                    statements.section_active = true;
                }

                if (activeElem != null) {
                    if (activeElem.getAttribute('id') !== 'navBarListHome') {
                        activeNavBar.animation.reverse();
                    }

                    activeElem.classList.remove('active');
                }

                targetNavbar.animation.play();
                targetNavbarList.classList.add('active');
            }
        });
    });

    document.querySelectorAll('.navbar-list').forEach(elem => {
        if (!isTouchDevice) {
            elem.addEventListener('mouseenter', function() {
                if (!statements.animation_running) {
                    const targetNavbar  = document.querySelector(this.getAttribute('data-path-start-id'));
                    const targetMain    = document.querySelector(this.getAttribute('data-target-main-path-id'));
                    const activeElem    = document.querySelector('.navbar-list.active');
                    if (targetNavbar && targetMain && !this.classList.contains('opened') && (this != activeElem)) {
                        targetNavbar.animation.play();
                        if (!statements.section_active) {
                            targetMain.animation.play();
                        }
                    }
                }
            });

            elem.addEventListener('mouseleave', function() {
                if (!statements.animation_running) {
                    const targetNavbar  = document.querySelector(this.getAttribute('data-path-start-id'));
                    const targetMain    = document.querySelector(this.getAttribute('data-target-main-path-id'));
                    const activeElem    = document.querySelector('.navbar-list.active');
                    if (targetNavbar && targetMain && !this.classList.contains('opened') && (this !== activeElem)) {
                        targetNavbar.animation.reverse();
                        if (!statements.section_active) {
                            targetMain.animation.reverse();
                        }
                    }
                }
            });

        }

        elem.addEventListener('click', function() {
            if (!statements.animation_running && !elem.classList.contains('active') && elem.getAttribute('data-target-section') !== '#none') {
                statements.animation_running = true;

                const targetNavbar  = document.querySelector(this.getAttribute('data-path-start-id'));
                const targetMain    = document.querySelector(this.getAttribute('data-target-main-path-id'));
                const activeElem    = document.querySelector('.navbar-list.active');
                let activeNavBar    = null;
                if (activeElem != null) {
                    activeNavBar = document.querySelector(activeElem.getAttribute('data-path-start-id'));
                }

                if (targetMain && targetNavbar && !this.classList.contains('opened')) {
                    targetNavbar.animation.reverse();
                    targetMain.animation.reverse();
                }

                if (!statements.section_active) {
                    gsap.to(ids.taglineTop, {duration: 0.2, opacity: 0, skewX: '-90deg'});
                    gsap.to(ids.taglineBottom, {duration: 0.2, opacity: 0, skewX: '90deg'});
                    timelines.main.timeScale(2.9).reverse();
                    statements.section_active = true;
                }

                if (activeElem != null) {
                    if (activeElem.getAttribute('id') !== 'navBarListHome') {
                        activeNavBar.animation.reverse();
                    }
                    
                    activeElem.classList.remove('active');
                }

                targetNavbar.animation.play();
                elem.classList.add('active');

                if (statements.section_active && activeElem.getAttribute('data-target-section') != '#sectionHome') {
                    document.querySelector(activeElem.getAttribute('data-target-section')).animation.reverse();
                }
            }
        });
    });
}